import { ProductSourceDto } from "definitions/product-storage";
import { useEffect } from "react";
import { SourceCode } from "src/constants/sources";
import { findCachedPlatform } from "src/pages/ProductDetailPage/store/fetchers/getProductDetailWithPrice";

export const useCachedPlatform = (
  sources: ProductSourceDto[] | undefined,
  isEnabled: boolean,
  onFound: (platform: SourceCode) => void,
) => {
  useEffect(() => {
    if (!isEnabled) return;

    let isActive = true;

    findCachedPlatform(sources).then((platform) => {
      if (isActive && platform) onFound(platform);
    });

    return () => {
      isActive = false;
    };
  }, [sources, isEnabled, onFound]);
};
